import React from 'react';
import SimpleReportForm from '../SimpleReportForm';
import GenericSurepassOutputComponent from '../output/GenericSurepassOutputComponent';

const ItrDownloadItrInputComponent = () => (
    <SimpleReportForm
        banner={{ icon: 'pi-download', title: 'ITR Download Return', subtitle: 'Initiate download of an Income Tax Return' }}
        fields={[
            { name: 'client_id', label: 'Client ID', icon: 'pi-key', placeholder: 'itr_xxxxxxxxxxxxx', maxLength: 100, mono: true,
              colClass: 'col-12 md:col-8 lg:col-6' },
        ]}
        endpoint={{
            path: '/surepass/itr/download-itr',
            bodyMapper: (v, sid) => ({ client_id: v.client_id.trim(), api_provider_service_id: parseInt(sid, 10) }),
        }}
        consentReportType="itr-download-itr"
        submitLabel="Download ITR"
        successSummary="ITR download initiated"
        errorSummary="ITR download failed"
        confirmHeader="Confirm ITR download"
        confirmAcceptLabel="Yes, download"
        outputComponent={GenericSurepassOutputComponent}
        outputProps={{ title: 'Income Tax Return', icon: 'pi-download' }}
    />
);

export default ItrDownloadItrInputComponent;
